import { call, put, takeLatest } from "redux-saga/effects";

import { PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import {
	getRatingContentAPI,
	getRatingContentsAPI,
	getRatingsAPI,
	udpateRatingContentAPI,
	udpateRatingContentStatusAPI,
} from "service/apis/rating";
import { translate } from "utils";
import { ContentItem } from "../content/types";
import { formatRatingsResponse } from "../utils";
import {
	GetRatingContentPayload,
	GetRatingContentsPayload,
	GetRatingsPayload,
	UpdateRatingContentPayload,
	UpdateRatingContentStatusPayload,
	getRatingContentAsync,
	getRatingContentsAsync,
	getRatingsAsync,
	setContentItems,
	setCustomerRatingTotal,
	setCustomerRatings,
	setMerchantRatingTotal,
	setMerchantRatings,
	setRatingContentDetail,
	setRatingContentIsSaved,
	setRatingContentList,
	updateRatingContentAsync,
	updateRatingContentStatusAsync,
} from "./ratingContent.slice";

function* getRatingContentsSaga(
	action: PayloadAction<GetRatingContentsPayload>,
) {
	const { callback } = action.payload;

	const { response, error } = yield call(async () => {
		try {
			const response = await getRatingContentsAPI().then(res => res);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	callback?.();
	if (response) {
		yield put({ type: setRatingContentList.type, payload: response });
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetRatingContents() {
	yield takeLatest(getRatingContentsAsync, getRatingContentsSaga);
}

function* getRatingContentSaga(action: PayloadAction<GetRatingContentPayload>) {
	const { callback, id } = action.payload;

	const { response, error } = yield call(async () => {
		try {
			const response = await getRatingContentAPI(id).then(res => res.data);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	callback?.();
	if (response) {
		console.log(response.ratingTypeDetail);
		yield put({ type: setRatingContentDetail, payload: response.ratingType });
		yield put({
			type: setContentItems.type,
			payload: Object.values(response.ratingTypeDetail).length
				? Object.values(response.ratingTypeDetail)
				: Object.values({
						"1": [
							{
								content: {
									en: "",
									km: "",
									zh: "",
								},
								rate: 1,
								status: true,
							},
						],
						"2": [
							{
								content: {
									en: "",
									km: "",
									zh: "",
								},
								rate: 2,
								status: true,
							},
						],
						"3": [
							{
								content: {
									en: "",
									km: "",
									zh: "",
								},
								rate: 3,
								status: true,
							},
						],
						"4": [
							{
								content: {
									en: "",
									km: "",
									zh: "",
								},
								rate: 4,
								status: true,
							},
						],
						"5": [
							{
								content: {
									en: "",
									km: "",
									zh: "",
								},
								rate: 5,
								status: true,
							},
						],
				  }),
		});
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetRatingContent() {
	yield takeLatest(getRatingContentAsync, getRatingContentSaga);
}

function* updateRatingContentSaga(
	action: PayloadAction<UpdateRatingContentPayload>,
) {
	const { callback, id, items, successCallback } = action.payload;

	const { response, error } = yield call(async () => {
		try {
			const response = await udpateRatingContentAPI(items, id).then(
				res => res.data,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	callback?.();
	if (response) {
		const contentItems: Array<Array<ContentItem>> = Array(5).fill([]);
		for (let index = 0; index < response.length; index++) {
			const itemIndex = response[index].rate - 1;
			response[index].isSaved = true;
			contentItems[itemIndex] = contentItems[itemIndex].concat([
				response[index],
			]);
		}
		yield put({
			type: setContentItems.type,
			payload: Object.values(contentItems),
		});
		yield put({ type: setRatingContentIsSaved.type, payload: true });
		message.success(translate("Update successful"));

		successCallback?.();
	} else {
		message.error(translate(error.message));
	}
}

function* watchUpdateRatingContent() {
	yield takeLatest(updateRatingContentAsync, updateRatingContentSaga);
}

function* updateRatingContentStatusSaga(
	action: PayloadAction<UpdateRatingContentStatusPayload>,
) {
	const { callback, id, status, successCallback } = action.payload;

	const { response, error } = yield call(async () => {
		try {
			const response = await udpateRatingContentStatusAPI(status, id).then(
				res => res.data,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	callback?.();
	if (response) {
		yield put({ type: setRatingContentDetail.type, payload: response });
		message.success(translate("Update successful"));

		successCallback?.();
	} else {
		message.error(translate(error.message));
	}
}

function* watchUpdateRatingContentStatus() {
	yield takeLatest(
		updateRatingContentStatusAsync,
		updateRatingContentStatusSaga,
	);
}

function* getRatingsSaga(action: PayloadAction<GetRatingsPayload>) {
	const { query, language, callback, successCallback } = action.payload;

	const { response, error } = yield call(async () => {
		try {
			const response = await getRatingsAPI(query, language).then(res => res);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	callback?.();
	if (response) {
		const ratings = formatRatingsResponse(response.data);
		if (query.app === "customer") {
			yield put({ type: setCustomerRatings.type, payload: ratings });
			yield put({ type: setCustomerRatingTotal.type, payload: response.total });
		} else if (query.app === "merchant") {
			yield put({ type: setMerchantRatings.type, payload: ratings });
			yield put({ type: setMerchantRatingTotal.type, payload: response.total });
		}
		successCallback?.();
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetRatings() {
	yield takeLatest(getRatingsAsync, getRatingsSaga);
}

const ratingContentSaga = [
	watchGetRatingContents(),
	watchGetRatingContent(),
	watchUpdateRatingContent(),
	watchUpdateRatingContentStatus(),
	watchGetRatings(),
];

export default ratingContentSaga;
